import * as Tone from 'tone';

// Reverb send bus. Instrument channels route signal here via their per-channel
// "Rev" send knob in the mixer. Wet=1 because the dry path is on the source
// channel; this bus only carries the wet (reverb-only) signal.

export default {
    id: 'fx-reverb',
    name: 'Reverb',
    register(ctx) {
        const reverb = new Tone.Reverb({ decay: 3.5, preDelay: 0.02, wet: 1 });
        // Tone.Reverb generates an impulse-response on first connection;
        // calling .ready awaits the IR build but isn't required for use.
        reverb.generate?.();
        const ch = ctx.mixer.addFxChannel({
            id: 'fx-reverb',
            name: 'Reverb',
            color: '#7aa2f7',
            effectNode: reverb,
        });
        ch.setVolume(-3);
    },
};
